import React, {useEffect, useState} from 'react';
import {Button, Flex} from 'antd';
import {
    ArrowsClockwise,
    ArrowsOut,
    BoundingBox,
    Cube,
    Pencil,
    PersonArmsSpread,
    Perspective,
    Ruler,
    X
} from '@phosphor-icons/react';
import {useCurrentUser} from '../../../../contexts/UserContext';
import {useViewerStore} from "../../../../store/store";
import {setPathname} from "@/helpers/storeHelpers";
import {registerRef} from "../../../../helpers/storeHelpers";

const Toolbar = () => {

    const pathname = useViewerStore(state => state.pathname)
    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const {user, hasCapability} = useCurrentUser();

    const isStreetViewVisible = useViewerStore((state) => state.isStreetViewVisible);
    const isTapeMeasureActive = useViewerStore((state) => state.isTapeMeasureActive);

    const [isOpen, setIsOpen] = useState(true);
    const [rotateActive, setRotateActive] = useState(false);
    const is2DModeActive = useViewerStore(state => state.is2DModeActive);
    const is3DModeActive = useViewerStore(state => state.is3DModeActive);

    //Handlers

    const setViewTo2DHandler = () => {
        sceneViewer.viewMode = '2d';

        useViewerStore.setState({
            is2DModeActive: true,
            is3DModeActive: false,
        })

        sceneViewer.setAutoRotate(false);
        sceneViewer.setCameraView('2d');
    }

    const setViewTo3DHandler = () => {
        useViewerStore.setState({
            is2DModeActive: false,
            is3DModeActive: true,
        });

        sceneViewer.viewMode = '3d';
        sceneViewer.setCameraView('3d')
    }

    const autoRotate = () => {
        setRotateActive((rotateActive) => !rotateActive);
        sceneViewer.setAutoRotate(!rotateActive);
    }

    const fullScreenHandler = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
            // document.body.classList.add('full-screen');
            useViewerStore.setState({
                isRightSidebarOpen: false,
            });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
                // document.body.classList.remove('full-screen');
                useViewerStore.setState({
                    isRightSidebarOpen: true,
                });
            }
        }

    }

    const streetViewHandler = () => {
        sceneViewer.loadStreetView();
        useViewerStore.setState({isStreetViewVisible: true, isRightSidebarOpen: false});
    }
    const topViewHandler = () => {
        sceneViewer.setTopView(true);
    }

    const measurementRedirectHandler = () => {
        if (!pathname.includes('tape-measure')) {
            useViewerStore.setState({isTapeMeasureActive: true})
            setPathname('/configure/tape-measure')
        } else {
            useViewerStore.setState({isTapeMeasureActive: false})
            setPathname('/configure/roof')
        }
    }


    useEffect(() => {
        if (user && !pathname.includes('tape-measure')) {
            useViewerStore.setState({isTapeMeasureActive: false})
        }
    }, [pathname, user]);


    // useEffect(() => {
    //
    //     if(sceneViewer==null) return;
    //
    //     if(is2DModeActive){
    //         sceneViewer.viewerAlert({
    //             title: '2D View',
    //             message: "",
    //             messageType: 'info',
    //             isToast: true
    //     })
    //
    //
    //         setTimeout(sceneViewer.removeViewerAlert, 1500)
    //     }
    //     else {
    //         sceneViewer.viewerAlert({
    //             title: '3D View',
    //             message: "",
    //             messageType: 'info',
    //             isToast: true
    //         })
    //
    //         setTimeout(sceneViewer.removeViewerAlert, 1500)
    //
    //     }
    //
    //     return()=>{
    //         clearTimeout(sceneViewer.removeViewerAlert)
    //
    //     }
    //
    // }, [is2DModeActive,is3DModeActive,sceneViewer]);

    return (
        <>
            <div className='toolbar'>
                <Flex gap={15}>
                    <Button
                        title={!isOpen ? "Close Toolbar" : "Open Toolbar"}
                        type='default'
                        size='large'
                        icon={isOpen ? <Pencil size={28} weight='fill'/> : <X size={28} weight='bold'/>}
                        onClick={() => setIsOpen(!isOpen)}
                    />
                    <Flex gap={5} hidden={isOpen} id='CanvasToolbar'>
                        {(hasCapability('Google_Streetview')) && (
                            <Button
                                title={"Street View"}
                                type={isStreetViewVisible ? 'primary' : 'default'}
                                size='large'
                                icon={<PersonArmsSpread size={26} weight='fill'/>}
                                onClick={streetViewHandler}
                                id='streetViewTool'
                            />
                        )}
                        {hasCapability('Tape_Measure') && (
                            <Button
                                ref={registerRef("btnMeasure")}
                                title={"Tape Measure"}
                                type={isTapeMeasureActive ? 'primary' : 'default'}
                                size='large'
                                icon={<Ruler size={26} weight='fill'/>}
                                onClick={measurementRedirectHandler}
                            />
                        )}
                        {hasCapability('360_View') && (
                            <Button
                                title={"360 View"}
                                type={rotateActive ? 'primary' : 'default'}
                                size='large'
                                icon={<ArrowsClockwise size={26} weight='fill'/>}
                                id='btnAutoRotate'
                                onClick={autoRotate}
                            />
                        )}
                        {hasCapability('Top_View') && (
                            <Button
                                title={"Top View"}
                                type={'default'}
                                size='large'
                                icon={<BoundingBox size={26} weight='fill'/>}
                                id='btnTopView'
                                onClick={topViewHandler}
                            />
                        )}

                        <Button
                            title={"Full Screen"}
                            type={'default'}
                            size='large'
                            icon={<ArrowsOut size={28} weight='fill'/>}
                            id='fullScreen'
                            onClick={fullScreenHandler}
                        />
                        {hasCapability('2D_View') && (
                            <Button
                                title={is2DModeActive ? "2D View" : "3D View"}
                                type={is2DModeActive ? 'primary' : 'default'}
                                size='large'
                                icon={<Perspective size={26} weight='fill'/>}
                                id='2DViewBtn'
                                onClick={setViewTo2DHandler}
                            >
                                2D
                            </Button>

                        )}
                        {hasCapability('3D_View') && (
                            <Button
                                title={"3D View"}
                                type={is3DModeActive ? 'primary' : 'default'}
                                size='large'
                                icon={<Cube size={26} weight='fill'/>}
                                id='3DViewBtn'
                                onClick={setViewTo3DHandler}
                            >
                                3D
                            </Button>
                        )}
                    </Flex>
                </Flex>
            </div>
        </>
    );
}

export default Toolbar;
